import { getCompanyAccountDetails } from "./company-api";
import { CompanyContactInfo } from "./components/CompanyContactInfo/CompanyContactInfo";
import CompanyProfile from "./CompanyProfile";

export const companyFeature = { api: { getCompanyAccountDetails } };

export { CompanyContactInfo, CompanyProfile };
